module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M1.712 1.24h12.6v13.52h-12.6z\"></path></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/icons/03-stop.svg
 ** module id = 145
 ** module chunks = 0
 **/